"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortMessages = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
function sortMessages(messages) {
    return messages.sort((a, b) => {
        return (0, moment_timezone_1.default)(a.commentDate).diff((0, moment_timezone_1.default)(b.commentDate), 'milliseconds');
    });
}
exports.sortMessages = sortMessages;
exports.default = sortMessages;
